import React from 'react';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import Loader from 'sharedComponents/Loader';

import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const LoanOfficersList = props => {
  const { loanOfficers, isLoading, isUpdating, onActivate } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.loader}>
        <Loader />
      </div>
    );
  }

  if (isBlank(loanOfficers)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.RealEstateAgentDashboard.FavoriteLoanOfficersList.noLoanOfficers')}
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      {loanOfficers.map(({ id, attributes }) => (
        <LoanOfficerCard key={id} loanOfficer={attributes} onActivate={onActivate} isUpdating={isUpdating} />
      ))}
    </div>
  );
};

LoanOfficersList.propTypes = {
  loanOfficers: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
  onActivate: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool.isRequired,
};

LoanOfficersList.defaultProps = {
  loanOfficers: [],
};

export default LoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/components/FavoriteLoanOfficersList/FavoriteLoanOfficersList.js